module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/SPG-prem.f855fa38.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/SPG-prem.png
// module id = 2714
// module chunks = 11